/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import React, {useContext} from 'react'
import {AuthContext, MccModule, useLocale, useNotification, useUser} from '@enisco/mcc-react-lib'
import useCurrentApp from '../../hooks/useCurrentApp'
import {useIntl} from 'react-intl'
import {KeycloakLoginOptions} from 'keycloak-js'
import {Backdrop, Box, CircularProgress} from '@mui/material'

const AppLauncher: React.FC = () => {
  const [currentApp] = useCurrentApp()
  const authContext = useContext(AuthContext)
  const notification = useNotification()
  const [user] = useUser()
  const [locale] = useLocale()
  const intl = useIntl()

  if (currentApp && !currentApp.hasAccess) {
    if (user) {
      notification(
        'warning',
        intl.formatMessage({
          id: 'AppLauncher.RequiredPermissions',
          defaultMessage: 'You do not have the required permissions.'
        })
      )
    } else {
      const options: KeycloakLoginOptions = {
        redirectUri: window.location.href,
        locale: locale
      }
      const loginUrl = authContext.keycloak?.createLoginUrl(options)

      notification(
        'warning',
        intl.formatMessage(
          {
            id: 'AppLauncher.RequiredPermissionsWithoutLogin',
            defaultMessage:
              'You do not have the required permissions. [Login with your username and password.]({loginUrl})'
          },
          {loginUrl: loginUrl}
        )
      )
    }
  }

  if (!currentApp) {
    return <Backdrop open={true} data-testid={'AppLauncher:loading'}>
      <CircularProgress/>
    </Backdrop>
  }

  return (
    <Box
      sx={{display: 'flex', backgroundColor: 'background.default'}}
      data-testid={'AppLauncher:root'}
    >
      {currentApp.hasAccess ? (
        <MccModule
          name={'app'}
          title={currentApp.app}
          sx={{flex: '1 1 auto', height: 'calc(100vh - 64px)', padding: 2}}
          url={currentApp.url}
        />
      ) : undefined}
    </Box>
  )
}

export default AppLauncher
